/**
 * Browser storage for per-viewer conveniences only (pane sizes, rail mode, theme). Never state
 * that must persist or be shared. Every access is guarded: private windows and blocked site data
 * throw, and the UI must render correctly without it.
 */
export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return globalThis.localStorage?.getItem(key) ?? null
    } catch {
      return null
    }
  },
  setItem(key: string, value: string): void {
    try {
      globalThis.localStorage?.setItem(key, value)
    } catch {
      /* convenience only */
    }
  },
}
